export function parseJSON<T>(value: string | null | undefined): T | undefined {
    return value != null ? JSON.parse(value) : undefined;
}
